module.exports = __webpack_public_path__ + "static/fonts/Roboto-Light.d647986.woff";